import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'

export const YEAR = 'year'
export const MONTH = 'month'
export const DAY = 'day'

const dayMonthYear = [DAY, MONTH, YEAR]
const monthDayYear = [MONTH, DAY, YEAR]
export const mapDateOfBirthConfiguration = (storeId) => {
  switch (storeId) {
    case WcsStoreId.USA:
      return monthDayYear
    case WcsStoreId.CANADA:
      return monthDayYear
    default:
      return dayMonthYear
  }
}
